(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('ComuneDeleteController',ComuneDeleteController);

    ComuneDeleteController.$inject = ['$uibModalInstance', 'entity', 'Comune'];

    function ComuneDeleteController($uibModalInstance, entity, Comune) {
        var vm = this;

        vm.comune = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Comune.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
